//     This code was generated by a Reinforced.Typings tool. 
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { GroupMembershipsRemovedResultDto } from '../../group/dto/GroupMembershipsRemovedResultDto';
import { IApiRequest } from '../../IApiRequest';

export class RemoveMembersFromGroupRequest extends IApiRequest<GroupMembershipsRemovedResultDto>
{
	public $type = 'RemoveMembersFromGroupRequest';
	constructor(public data: { groupId: string, companyId: string, userIds: string[] }) { super(); }
}
